import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

export function useSpaces({ settingsView }: { settingsView: boolean }) {
  return useQuery(queries.spacesLite({ includeAdminSpaces: settingsView }));
}

type WithRoleGrants = { roleGrantsAsScope?: readonly unknown[] };

export function isSpaceMember(space: WithRoleGrants): boolean {
  return (space.roleGrantsAsScope?.length ?? 0) > 0;
}
